import styled, { css, keyframes } from "styled-components"

export const keyFrameCircle = keyframes`
  0% { opacity: 1; scale:1; }
  60% { opacity: 0.6; }
  80% { opacity: 0.3; scale:120; }
  100% { opacity: 0; scale:120; }
`
const StyledWrap = styled.div`
  width: 100%;
`

const StyledColorAnimation = styled.div<{
  $color: string
  $colorChange: boolean
  $animationTime?: string
}>`
  width: 50px;
  height: 50px;
  margin: 0px auto;
  border-radius: 100%;
  background-color: ${(p) => p.$color};
  z-index: 10;
  opacity: 0;
  animation: ${({ $colorChange, $animationTime }) =>
    $colorChange &&
    css`
      ${keyFrameCircle} ${$animationTime
        ? "2000ms linear forwards"
        : "1200ms linear forwards"}
    `};
  /* mix-blend-mode: multiply; */
`

type ColorCircleAnimationProps = {
  animationFlag: boolean
  hex: string
  className?: string
  animationTime?: string
}

const ColorCircleAnimation = ({
  animationFlag,
  hex,
  className,
  animationTime,
}: ColorCircleAnimationProps) => {
  return (
    <>
      {animationFlag && (
        <StyledWrap className={className}>
          <StyledColorAnimation
            $colorChange={animationFlag}
            $color={hex}
            $animationTime={animationTime}
          />
        </StyledWrap>
      )}
    </>
  )
}

export default ColorCircleAnimation
